import { render } from "./carrito.vue?vue&type=template&id=1ac2b7bb"
import script from "./carrito.vue?vue&type=script&lang=js"
export * from "./carrito.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__